import { createPortal } from "react-dom";
import { ArrowRightLeft, CalendarHeart, CheckSquare, Copy, Download, FolderPlus, Minus, Trash2, X } from "lucide-react";

// Multi-select action bar, fixed across the top of the screen (covers the header while selecting)
export const SelectionDock = ({ count, onAction, onClear, onSelectAll, album }) => {
  if (!count) return null;
  const btn = (key, icon, label, extra = "") => (
    <button className={`dock-btn ${extra}`} onClick={() => onAction(key)} data-testid={`bulk-${key}-button`}>{icon}<span>{label}</span></button>
  );
  return createPortal(
    <div className="dock" role="toolbar" aria-label="Selected photos" data-testid="multi-select-dock">
      <div className="dock-inner">
        <button className="dock-btn" onClick={onClear} aria-label="Clear selection" data-testid="bulk-clear-button"><X size={16} /></button>
        <span className="dock-count" data-testid="selected-items-count">{count} selected</span>
        {btn("album", <FolderPlus size={16} />, "Add to album / New album")}
        {btn("move", <ArrowRightLeft size={16} />, "Move")}
        {btn("copy", <Copy size={16} />, "Copy")}
        {btn("event", <CalendarHeart size={16} />, "Set event")}
        {btn("download", <Download size={16} />, "Download")}
        {album?.canRemove && btn("remove", <Minus size={16} />, "Remove from album")}
        {btn("delete", <Trash2 size={16} />, "Delete", "dock-danger")}
        <span className="dock-spacer" />
        <button className="dock-btn" onClick={onSelectAll} data-testid="bulk-select-all-button"><CheckSquare size={16} /><span>Select all</span></button>
        <button className="dock-btn" onClick={onClear} data-testid="bulk-clear-text-button"><span>Clear</span></button>
      </div>
    </div>,
    document.body,
  );
};
